// React specific
import React, { ChangeEvent } from 'react';
import ButtonWithButtonTextAnimation from './ButtonWithButtonTextAnimation';

const CopyToClipboardField = ({
  icon: Icon,
  buttonIcon,
  label,
  buttonText,
  copiedText,
  inputValue,
  onChange,
  inputPlaceholder,
}: {
  icon: string;
  buttonIcon: string;
  label: string;
  buttonText: string;
  copiedText: string;
  inputValue: string;
  onChange: (e: ChangeEvent) => void;
  inputPlaceholder?: string;
}): JSX.Element => {
  // Test function for copy some string to the  clipboard
  function copyStringToClipboard(): void {
    navigator.clipboard.writeText(inputValue);
  }

  return (
    <div className="flex flex-col justify-between">
      <p className="font-base font-pt-sans font-bold m-0">{label}</p>

      <div className="flex sm:border flex-col sm:flex-row items-center sm:border-gray-200 sm:bg-white sm:rounded-full">
        <div className="flex border sm:border-none border-gray-200 rounded w-full sm:mb-0 mb-10 bg-white sm:bg-transparent">
          <Icon className="m-10 fill-primary" />
          <input
            data-testid={'CopyToClipboardField'}
            readOnly={true}
            className="flex flex-1 border-none max-w-none outline-none"
            placeholder={inputPlaceholder}
            value={inputValue}
            onChange={onChange}
          />
        </div>
        <ButtonWithButtonTextAnimation
          secondButtonText={copiedText}
          firstButtonText={buttonText}
          buttonClick={copyStringToClipboard}
          buttonIcon={buttonIcon}
          theme="input"
        />
      </div>
    </div>
  );
};

export default CopyToClipboardField;
